import { Snackbar, Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ProfileIncompleteAlertProps {
  message: React.ReactNode;
  open: boolean;
  onClose: () => void;
}

export const ProfileIncompleteAlert = ({
  message,
  open,
  onClose,
}: ProfileIncompleteAlertProps) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ maxWidth: '600px', width: '100%' }}
    >
      <Alert
        severity="warning"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ width: '100%', bgcolor: '#fc0841', color: '#fff' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
